import { TagTypesFromApi } from '@reduxjs/toolkit/dist/query/endpointDefinitions';

import { generatedOpenAPI } from '../generated/generatedOpenAPI';

type TagTypes = TagTypesFromApi<typeof generatedOpenAPI>;

export const stellarApiEnhanced = generatedOpenAPI.enhanceEndpoints<TagTypes>({
  endpoints: {
    /* Scope UPLOAD tags by experimentId so mutations refetch
       the validation result for the affected experiment. */
    getValidationResultApiStellarUploadExperimentIdValidationResultsGet: {
      providesTags: (_result, _error, arg) => [{ type: 'UPLOAD', id: arg.experimentId }],
    },
    validateAntibodyCsvFileApiStellarUploadValidateExperimentIdFileNamePost: {
      invalidatesTags: (_result, _error, arg) => [{ type: 'UPLOAD', id: arg.experimentId }],
    },
    deleteFileApiStellarUploadExperimentIdFileNameDelete: {
      invalidatesTags: (_result, _error, arg) => [{ type: 'UPLOAD', id: arg.experimentId }],
    },
    uploadFileApiStellarUploadPost: {
      invalidatesTags: [],
    },

    /* Scope EXPERIMENT mutations to refresh the experiments list
     */
    getExperimentsApiStellarExperimentsGet: {
      providesTags: [{ type: 'EXPERIMENT', id: 'LIST' }],
    },
    deleteExperimentApiStellarExperimentsIdDelete: {
      invalidatesTags: [{ type: 'EXPERIMENT', id: 'LIST' }],
    },
    createExperimentApiStellarExperimentsPost: {
      invalidatesTags: [{ type: 'EXPERIMENT', id: 'LIST' }],
    },
    pruneExperimentsApiStellarExperimentsPrunePost: {
      invalidatesTags: [{ type: 'EXPERIMENT', id: 'LIST' }],
    },
  },
});
